{
  "version": 1,
  "asset_id": "0e5b2869-0998-4e23-bc83-efe2a8df80ab",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0e5b2869-0998-4e23-bc83-efe2a8df80ab/svc-cro-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0e5b2869-0998-4e23-bc83-efe2a8df80ab/svc-cro-1200.webp",
  "original_filename": "svc-cro-1200.webp",
  "size": 13230,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:46Z"
}
